<template>
  <v-form ref="form" @submit.prevent="reactivateClick">
    <div>
      <div v-if="loading" class="text-center align-center py-8">
        Loading...
      </div>

      <div v-show="!loading" ref="stripe_pm" />
    </div>

    <v-checkbox v-model="autoRefill" dense hide-details class="mb-4" :disabled="loading">
      <template #label>
          <div style="font-size: 12px; line-height: 1.25;">
            Enable auto-refill of your account.   You can adjust your settings on your auto-refill page.
          </div>
        </template>
    </v-checkbox>

    <v-divider class="my-4"/>

    <div class="d-flex justify-center mt-4 mb-2">
      <v-btn @click="$router.back()">Cancel</v-btn>
      <v-btn :disabled="loading" type="submit" color="primary" class="ml-2">
        Reactivate
      </v-btn>
    </div>

    <ErrorOverlay
      title="Error" v-model="error_dialog"
      :loading="loading" :message="error_message"
    />
  </v-form>
</template>

<script>
import ErrorOverlay from '@/components/pages/ErrorOverlay'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'BillingNewPaymentMethodView',

  components: { ErrorOverlay },

  data: () => ({
    autoRefill: true,
    paymentElement: null,
    secretLoaded: null,
    stripeElements: null,

    existing: true,
    payment_method: null,

    // error handling
    loading: true,
    error_dialog: false,
    error_message: '',
  }),

  computed: {
    ...mapGetters('billing', ['newCardSecret']),
  },

  watch: {
    async autoRefill(refill_enabled) {
      console.log(this.newCardSecret.client_secret)

      const { payment_id, client_secret: payment_intent } = this.newCardSecret
      await this.toggleCardSecret( { refill_enabled, payment_id, payment_intent } )

      console.log(this.newCardSecret.client_secret)
    },
  },

  methods: {
    ...mapActions('billing', ['loadNewCardSecret', 'toggleCardSecret']),

    async reactivateClick() {
      this.loading = true 
      const { error } = await this.$stripe.confirmPayment({
        elements: this.stripeElements,

        confirmParams: {
          return_url: `${ location.origin }/reactivate/confirm`,

          payment_method_data: {
            billing_details: {
              address: {
                country: 'US',
              },
            },
          },
        },
      })

      if (error) {
        this.error_message = 'Our credit card processor is unable to accept this card.  Please check you that have the correct number, CVC and zip code.'
        this.error_dialog = true
        this.loading = false
      }
    }
  },

  created() {
    this.secretLoaded = this.loadNewCardSecret()
  },

  async mounted() {  
    await this.secretLoaded
        
    const appearance = {
      theme: 'stripe',

      variables: {
        colorPrimary: this.$vuetify.theme.themes.light.primary,
        fontFamily: 'Roboto, sans-serif',
      }
    }

    const clientSecret = this.newCardSecret.client_secret

    this.stripeElements = this.$stripe.elements({
      clientSecret,
      appearance,
    })
        
    const fields = {
      billingDetails: {
        address: {
          country: 'never',
        },
      },
    }

    this.paymentElement = this.stripeElements.create('payment', { fields })
    this.paymentElement.on('ready', () => { this.loading = false })

    this.paymentElement.mount(this.$refs.stripe_pm)
  },
}
</script>